import { useMemo } from 'react';
import useAssetModels from './useAssetModels';
import { Option } from '@/components/inputs/AutocompleteInput';
import { AssetModelApi } from '../models';

interface UseAssetModelsOptionsProps {
  search?: string;
  minLength?: number;
  brandId?: string;
  page?: number;
  pageSize?: number;
}

const useAssetModelsOptions = ({ search, minLength = 3, brandId, page = 1, pageSize = 5 }: UseAssetModelsOptionsProps = {}) => {
  const shouldSearch = search && search.length >= minLength;
  const hasBrandId = brandId && typeof brandId === 'string' && brandId.trim() !== '';
  
  const { assetModels, isLoading, error } = useAssetModels({
    search: shouldSearch ? search : '',
    brandId: hasBrandId ? brandId : undefined,
    page,
    pageSize: shouldSearch ? pageSize : 5,
  });

  const assetModelOptions: Option[] = useMemo(
    () =>
      assetModels.map((model: AssetModelApi) => ({
        label: model.name,
        data: model.id,
      })),
    [assetModels]
  );

  return {
    assetModels,
    assetModelOptions,
    isLoading,
    error,
  };
};

export default useAssetModelsOptions;
